import { gql } from '@apollo/client';

import { IStatusResultEnum } from 'utils/enums/status';

export interface AcceptPersonInvitationResponse {
  clientMutationId: string;
  loginIdentifier: string;
  status: string;
}

export interface CompleteForgotPasswordResponse {
  message: string;
  status: IStatusResultEnum;
}

export interface ForgotPasswordResponse {
  clientMutationId: string;
  message: string;
  status: IStatusResultEnum;
}

export interface VerifyAccountResponse {
  clientMutationId: string;
  loginIdentifier: string;
  status: string;
}

export const ACCEPT_INVITATION_MUTATION = gql`
  mutation acceptPersonInvitation($input: AcceptPersonInvitationInput!) {
    acceptPersonInvitation(input: $input) {
      loginIdentifier
      loginIdentifierType
      status
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation completeForgotPassword($input: CompleteForgotPasswordInput!) {
    completeForgotPassword(input: $input) {
      message
      status
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation startForgotPassword($input: StartForgotPasswordInput!) {
    startForgotPassword(input: $input) {
      message
      status
    }
  }
`

export const VERIFY_ACCOUNT_MUTATION = gql`
  mutation verifyAccount($input: VerifyAccountInput!) {
    verifyAccount(input: $input) {
      loginIdentifier
      loginIdentifierType
      status
    }
  }
`;

const SIGNUP_MUTATION = gql`
  mutation SignUp(
    $loginIdentifier: String!
    $password: String!
    $loginIdentifierType: LoginIdentifierTypesEnum
    $name: String!
    $lastName: String
  ) {
    signUp(
      input: {
        loginIdentifier: $loginIdentifier
        password: $password
        loginIdentifierType: $loginIdentifierType
        name: $name
        lastName: $lastName
      }
    ) {
      requestStatus
      message
    }
  }
`;

export default SIGNUP_MUTATION;